// Edenstone Masonry — flat data-testid catalogue.
// Imported as: import { TESTIDS } from '@/constants/testIds';

export const TESTIDS = {
  // auth
  loginEmail: "login-email-input",
  loginPassword: "login-password-input",
  loginSubmit: "login-submit-button",
  loginError: "login-error",
  logoutBtn: "logout-button",
  // sidebar
  sbDashboard: "sidebar-dashboard-link",
  sbCompanies: "sidebar-companies-link",
  sbInventory: "sidebar-inventory-link",
  sbPipeline: "sidebar-pipeline-link",
  sbDockets: "sidebar-dockets-link",
  sbUsers: "sidebar-users-link",
  // dashboard
  dashKpiOrders: "dash-kpi-active-orders",
  dashKpiLowstock: "dash-kpi-low-stock",
  dashKpiDockets: "dash-kpi-pending-dockets",
  dashKpiCompanies: "dash-kpi-active-companies",
  // companies
  newCompanyBtn: "companies-new-button",
  newCompanySave: "companies-new-save",
  companyRow: (id) => `company-row-${id}`,
  // inventory
  newInventoryBtn: "inventory-new-button",
  inventoryRow: (id) => `inventory-row-${id}`,
  // pipeline
  pipelineCol: (status) => `pipeline-col-${status.replace(/\s+/g, "-").toLowerCase()}`,
  pipelineCard: (id) => `pipeline-card-${id}`,
  newOrderBtn: "pipeline-new-order-button",
  // dockets
  newDocketBtn: "dockets-new-button",
  docketConfirmBtn: (id) => `docket-confirm-${id}`,
  docketRow: (id) => `docket-row-${id}`,
  // users
  newUserBtn: "users-new-button",
  userRow: (id) => `user-row-${id}`,
};
